import { Vector2 } from '@babylonjs/core';
import { BaseShape } from './IShape';

export class SlotItem extends BaseShape {
    constructor(
        public url: string,
        public position: Vector2,
        public shape: Vector2,
    ) {
        super(position, shape);
    }
}
